import {
  RiBriefcase4Fill,
  RiLinksFill,
  RiMailFill,
  RiMapPinFill,
  RiTwitterFill,
} from 'react-icons/ri';

import DefaultImage from '@assets/imgs/default-image.png';

import ArrowBack from '@components/ArrowBack';

import { useUser } from '@contexts/UserContext';

import { Container, About, UserNumbers, Info } from './styles';

const Profile: React.FC = () => {
  const { user } = useUser();

  return (
    <Container data-cy="user-info">
      <ArrowBack color="white" />

      <About>
        <img src={user?.avatar_url ?? DefaultImage} alt="" />

        <div className="username">
          <span className="name">{user?.name}</span>
          <span className="login">@{user?.login}</span>
        </div>

        <p className="bio">{user?.bio}</p>
      </About>

      <UserNumbers>
        <a
          href={`https://github.com/${user?.login}?tab=followers`}
          target="_blank"
          rel="noreferrer"
          data-cy="followers"
        >
          <span className="number">{user?.followers} </span>
          Followers
        </a>
        <a
          href={`https://github.com/${user?.login}?tab=following`}
          target="_blank"
          rel="noreferrer"
          data-cy="following"
        >
          <span className="number">{user?.following} </span>
          Following
        </a>
        <a
          href={`https://github.com/${user?.login}?tab=repositories`}
          target="_blank"
          rel="noreferrer"
          data-cy="repos"
        >
          <span className="number">{user?.public_repos} </span>
          Repositories
        </a>
      </UserNumbers>

      <Info>
        {user?.location && (
          <li data-cy="location">
            <RiMapPinFill />
            {user?.location}
          </li>
        )}
        {user?.company && (
          <li data-cy="company">
            <RiBriefcase4Fill />
            {user?.company}
          </li>
        )}
        {user?.twitter_username && (
          <li data-cy="twitter">
            <a
              href={`https://twitter.com/${user?.twitter_username}`}
              target="_blank"
              rel="noreferrer"
            >
              <RiTwitterFill />@{user?.twitter_username}
            </a>
          </li>
        )}
        {user?.email && (
          <li data-cy="email">
            <a href={`mailto:${user?.email}`}>
              <RiMailFill />
              {user?.email}
            </a>
          </li>
        )}
        {user?.blog && (
          <li data-cy="blog">
            <a href={user?.blog} target="_blank" rel="noreferrer">
              <RiLinksFill />
              {user?.blog}
            </a>
          </li>
        )}
      </Info>
    </Container>
  );
};

export default Profile;
